import { render, staticRenderFns } from "./DeliveredOrders.vue?vue&type=template&id=dbb15f5c"
import script from "./DeliveredOrders.vue?vue&type=script&lang=js"
export * from "./DeliveredOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports